export enum PaymentMethodType {
    CARD,
    WALLET,
}